"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var native_exports = {};
__export(native_exports, {
  ONE_PLATFORM_ENV: () => import_env.ONE_PLATFORM_ENV,
  ONE_PUBLIC_PREFIX: () => import_env.ONE_PUBLIC_PREFIX,
  expoClientFromNativeApp: () => import_appManifest.expoClientFromNativeApp,
  pickOnePublicEnv: () => import_env.pickOnePublicEnv,
  validateNativeApp: () => import_appManifest.validateNativeApp
});
module.exports = __toCommonJS(native_exports);
var import_appManifest = require("./appManifest");
var import_env = require("./env");
//# sourceMappingURL=index.js.map
